import { ProjectsWeatherAlertModel } from "./ProjectsWeatherAlert.model";

export class ProjectsWeatherAlert extends ProjectsWeatherAlertModel {
    // Add custom methods here
}
